import React, { useCallback, useMemo } from 'react';
import { Box, InfoOutlineIcon, Inscription, LinkButton } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import useHistory from '@/modules/core/hooks/useHistory';

interface Props {
  planId: string;
}

const SpendLimitsInfoBanner: React.FC<Props> = ({ planId }) => {
  const { observingSearchQuery } = useHistory();

  const planLink = useMemo(() => {
    const basePath = ROUTES.PLAN_BY_ID(planId);
    return observingSearchQuery ? `${basePath}?${observingSearchQuery}` : basePath;
  }, [planId, observingSearchQuery]);

  const handleOpenPlan = useCallback(() => {
    window.open(planLink, '_blank');
  }, [planLink]);

  return (
    <Box
      data-testid={`spend-limits-info-banner_${planId}`}
      direction="row"
      align="center"
      gap="xxsmall"
      pad={{ horizontal: 'spacing16', vertical: 'spacing8' }}
      round="container2Round"
      background={{ color: 'infoContainer' }}
      border={{ color: 'infoBorder' }}
      margin={{ left: '56px' }}
    >
      <InfoOutlineIcon color="info" />
      <Inscription lineHeight="20px" data-testid={`spend-limits-info-banner_${planId}_text`}>
        Spend limits have already been configured for this plan.{' '}
        <LinkButton
          testId={`spend-limits-info-banner_${planId}_link`}
          onClick={handleOpenPlan}
          linkInlineMode
        >
          View spend limits
        </LinkButton>
      </Inscription>
    </Box>
  );
};

export default SpendLimitsInfoBanner;
